if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);

          // Tracking: Add to Cart events
          // /cart/add.js restituisce { items: [...] } oppure direttamente il line item
          const item = parsedState && parsedState.items ? parsedState.items[0] : parsedState;

          if (item && item.variant_id) {
            const variantId = String(item.variant_id);
            const itemPrice = item.final_price / 100;
            const itemQuantity = item.quantity || 1;

            // Google Ads - Add to Cart Conversion
            if (typeof gtag !== 'undefined') {
              gtag('event', 'conversion', {
                'send_to': 'AW-11012012228/NscFCNbm0IcYEMTx94Ip',
                'value': itemPrice * itemQuantity,
                'currency': 'EUR'
              });

              // GA4 - add_to_cart event
              gtag('event', 'add_to_cart', {
                currency: 'EUR',
                value: itemPrice * itemQuantity,
                items: [{
                  item_id: variantId,
                  item_name: item.product_title,
                  item_variant: item.variant_title,
                  price: itemPrice,
                  quantity: itemQuantity
                }]
              });
            }

            // Meta Pixel - AddToCart event
            if (typeof fbq !== 'undefined') {
              fbq('track', 'AddToCart', {
                content_ids: [variantId],
                content_name: item.product_title,
                content_type: 'product',
                value: itemPrice * itemQuantity,
                currency: 'EUR'
              });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  customElements.define('product-form', ProductForm);
}